import zh_CN from './zh_CN' // 中文
import en_US from './en_US' // 英语
import de_DE from './de_DE' // 德语
import es_ES from './es_ES' // 西班牙语
import fr_FR from './fr_FR' // 法语
import it_IT from './it_IT' // 意大利语
import pt_PT from './pt_PT' // 葡萄牙语

export default {
    zh: zh_CN,
    en: en_US,
    de: de_DE,
    es: es_ES,
    fr: fr_FR,
    it: it_IT,
    pt: pt_PT
}
